// Helper pour normalisation complète
export function normalizeString(str: string): string {
    return str
        .toLowerCase()
        .normalize("NFD") // Décompose les accents
        .replace(/[\u0300-\u036f]/g, ""); // Supprime les diacritiques
}
